// 活动模块
export const QRY_USERACT = '/app/promotion/prom_qry_useract.cgi';
export const QRY_USERACT_PRIZE = '/app/promotion/prom_qry_useract_prize.cgi';
export const TASK_SHOW = '/app/task/prom_batch_task_show_v2.cgi';
export const CHECK_USERACT = '/app/promotion/prom_batchcheck_act_blacklist.cgi';
export const EXEC_USERACT = '/app/promotion/prom_exec_act.cgi';
export const EXEC_CHAIN_USERACT = '/app/promotion/prom_combincoup_exec_act.cgi';
export const QRY_USER_DK_STATE = '/app/promotion/prom_qry_user_dk_state.cgi';
export const EBANK_NEWACC = '/app/promotion/prom_ebank_newacc.cgi';
export const GEN_SHARECODE = '/app/usershare/prom_gen_sharecode.cgi';
export const SHOW_PROMOTER_AWARDS = '/app/usershare/prom_show_promoter_awards.cgi';
export const SHOW_PROMOTER_INFO = '/app/usershare/prom_show_promoter_info.cgi';
export const QRY_PROMOTER_RANKING = '/app/usershare/prom_qry_promoter_ranking.cgi';
export const GET_SHAREPRIZE_COMM = '/app/usershare/prom_get_shareprize_comm.cgi';
export const QRY_ACT_INFO = '/app/usershare/prom_qry_act_info.cgi';
export const QRY_MARKS = '/app/mark/prom_qry_marks.cgi';
export const RECORD_MARK = '/app/mark/prom_record_mark.cgi';
